module.exports = __webpack_public_path__ + "static/img/3nieok.ff4305dd.webp";